import { Button, Result } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const PageNotFound: React.FC = () => (
  <>
    <Helmet>
      <title>404 | Page not found</title>
    </Helmet>
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={<Link to="/user-management"><Button type="primary">Back User Management</Button></Link>}
    />
  </>
);

export default PageNotFound;